import Button from "@atlaskit/button/new";
import {type ComponentProps, forwardRef} from "react";

export const AnankeButton = forwardRef<HTMLElement, ComponentProps<typeof Button> & {
    type: Exclude<ComponentProps<typeof Button>["type"], undefined>;
}>((props, ref) => {
    return <Button {...props} ref={ref as any} />;
});
